export const environment = {
  production: false,
  serverUrl: 'v1/api',
  socketConfig: {
    url: `${window.location.origin}`,
    options: { nonContextual: 'sci-chatbot-prod', contextual: 'sci-chatbot' },
  },
  msalEnabled: false,
  msalClient: 'c1bca007-bb2a-4f41-9fe9-5bfd6bac0fbf',
  msalTenant: '5b973f99-77df-4beb-b27d-aa0c70b8482c',
  msalRedirectUrl: 'https%3A%2F%2Fmondelez-sci.ey.com%2Fauth%2Fmsal-login',
  prodServerUrl: 'https%3A%2F%2Fmondelez-sci.ey.com',
  showBetaTestingInfo: true,
  showFrequentChatQuestion: false,
  allowedUserForChatbot: ['juanandres.simoneperez@mdlz.com', 'vikas.grover@mdlz.com', 'kiran.pai@mdlz.com', 'alexander.bonilla@mdlz.com', 'jaime.garzaramirez@mdlz.com'],
  inactive_session_in_seconds: 1200,
  session_timeout_warning_in_seconds: 300,
  session_logout_early_in_seconds: 120,
};
